import React from 'react';
import { Button, Box, Typography, Stack } from '@mui/material';
import { useNotification, NotificationProvider } from '../../context/NotificationContext';
import { useCreateTestNotification } from '../../context/NotificationContext';

const NotificationTestContent: React.FC = () => {
  const { showNotification, addNotification } = useNotification();
  const createTestNotification = useCreateTestNotification();
  
  const handleShowInfo = () => {
    showNotification('This is an info notification', 'info');
  };
  
  const handleShowSuccess = () => {
    showNotification('This is a success notification', 'success');
  };
  
  const handleShowWarning = () => {
    showNotification('This is a warning notification', 'warning');
  };
  
  const handleShowError = () => {
    showNotification('This is an error notification', 'error');
  };
  
  const handleAddPersistentNotification = () => {
    addNotification('This is a persistent notification', 'info');
  };
  
  const handleCreateTestNotifications = () => {
    createTestNotification('info');
    createTestNotification('success');
    createTestNotification('warning');
    createTestNotification('error');
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Notification Testing
      </Typography>
      
      <Stack spacing={2} direction="column" sx={{ mb: 4 }}>
        <Typography variant="h6">Toast Notifications</Typography>
        <Stack direction="row" spacing={2}>
          <Button variant="contained" color="info" onClick={handleShowInfo}>
            Show Info
          </Button>
          <Button variant="contained" color="success" onClick={handleShowSuccess}>
            Show Success
          </Button>
          <Button variant="contained" color="warning" onClick={handleShowWarning}>
            Show Warning
          </Button>
          <Button variant="contained" color="error" onClick={handleShowError}>
            Show Error
          </Button>
        </Stack>
      </Stack>
      
      <Stack spacing={2} direction="column">
        <Typography variant="h6">Persistent Notifications</Typography>
        <Stack direction="row" spacing={2}>
          <Button variant="outlined" color="primary" onClick={handleAddPersistentNotification}>
            Add Single Notification
          </Button>
          <Button variant="outlined" color="secondary" onClick={handleCreateTestNotifications}>
            Add All Types
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

// Wrapper component that provides the NotificationContext
const NotificationTest: React.FC = () => {
  return (
    <NotificationProvider>
      <NotificationTestContent />
    </NotificationProvider>
  );
};

export default NotificationTest;
